import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';
import LigneAdresse from '../Adresse';
import Contact from '../Contact';

const CardCoordonnees = ({
    Civilite, Nom, Adresse, LsContacts, ModifCoordOk, PageSaisieIBAN, 
}) => (
    <Card Titre={CardCoordonnees.titleName} SousTitre={`${Civilite} ${Nom}`}>
        <div className="card-text mb-3">
            {Adresse && <LigneAdresse className="mb-2" {...Adresse} />}
            {LsContacts.map((contact, i) => <Contact key={i} className="mb-2" {...contact} />)}
        </div>

        <Link to="/MesInformations/Coordonnees" hidden={PageSaisieIBAN}>
            <button className="btn btn-outline-orange">{ ModifCoordOk ? 'Modifier mes coordonnées' : 'Demander une modification'}</button>
        </Link>
    </Card>
);
CardCoordonnees.displayName = 'CardCoordonnees';
CardCoordonnees.titleName = 'Mes coordonnées';
CardCoordonnees.requiredProps = [
    'Civilite', // Civilité du propriétaire
    'Nom', // Nom du propriétaire
    'LsContacts', // Liste des contacts du propriétaire
];

function mapStateToProps({
    ProStore: {
        Pro: {
            Ind: {
                Civilite, Nom, Adresse, LsContacts,
            },
        },
    },
    SynStore: {
        Syn: {
            ModifCoordOk,
        },
    },
}) {
    return {
        Civilite,
        Nom,
        Adresse,
        LsContacts,
        ModifCoordOk,
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardCoordonnees));



// WEBPACK FOOTER //
// ./src/components/MesInfos/CardCoordonnees.js